import {
  BfBusinessDetails,
  BfClientDetails,
  BusinessFuelForm,
} from "redux-models/reduxStateTypes";
import {
  mapAddress,
  Merge,
  MergeFlag,
} from "helpers/mappers/mapApiToReduxCustomerDetails";

export const mapApiToReduxBfCustomer = ({
  resp,
  state,
  strategy = Merge.All,
}: {
  resp: any;
  state: BusinessFuelForm;
  strategy?: MergeFlag;
}): Partial<BusinessFuelForm> => {
  if (!resp) return state;
  const mapBusiness = (strategy & Merge.Business) === Merge.Business;
  const mapClients = (strategy & Merge.Clients) === Merge.Clients;
  return {
    businessDetails: mapBusiness
      ? mapBusinessDetails(resp)
      : state.businessDetails,
    clientDetails: mapClients ? mapClientDetails(resp) : state.clientDetails,
  };
};

export const mapBusinessDetails = (
  payload: any
): BfBusinessDetails | undefined => {
  return payload.generic
    ? {
        id: payload.generic.id,
        name: payload.generic.name,
        acn: payload.generic.acn,
        abn: payload.generic.abn,
        industry: payload.generic.industry,
        website: payload.generic.website,
        address: mapAddress(payload.generic.address),
        registration: payload.generic.registration,
      }
    : undefined;
};

export const mapClientDetails = (payload: any): BfClientDetails | undefined => {
  const contact = payload?.generic?.contact;
  return contact
    ? {
        id: contact.id,
        firstName: contact.firstName,
        lastName: contact.lastName,
        email: contact.email,
        mobilePhone: contact.mobilePhone,
        allowedDirectContact: contact?.allowedDirectContact,
      }
    : undefined;
};
